import { faCircleCheck, faHelmetSafety } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";

interface JobsitePPEInformationCardProps {
    project: any;
}

const JobsitePPEInformationCard: React.FC<JobsitePPEInformationCardProps> = ({ project }) => {
    return (
        <div className="flex flex-col gap-2">
            <div className="flex flex-row items-center gap-2">
                <FontAwesomeIcon icon={faHelmetSafety} className="text-plot-green" />
                <div className="text-lg font-semibold text-gray-900 dark:text-plot-darkmode-white">PPE Information</div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-2 p-4 rounded-lg shadow-sm border bg-gray-50 dark:bg-neutral-800 border-gray-200 dark:border-neutral-700">
                {project.ppe_required.map((item, index) => (
                    <div key={index} className="flex items-center gap-2 w-full">
                        <FontAwesomeIcon icon={faCircleCheck} className="text-plot-green" />
                        <div className="text-sm text-gray-900 dark:text-neutral-300">
                            {item?.toString() || "No PPE information provided"}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default JobsitePPEInformationCard;
